import { IdDescription } from '@app/entities/interfaces/data/iddescription.interface';
import {
  Knowledge,
  LanguageItem,
  LanguageLevels,
  LanguageMasters,
  Statuses,
  Tests
} from '@app/entities/interfaces/personal-data/employee-languages.interface';

export class EmployeeLanguages {
  knowledge!: Knowledge[];
  tests!: Tests[];
}

export class LanguageMastersModel implements LanguageMasters {
  languages!: LanguageItem[];
  levels?: LanguageLevels[];
  tests!: IdDescription[];
  statuses!: Statuses[];
}

export class CertificateEmployeeModel {
  language!: string;
  languageLevel!: string;
  certificate!: {
    status: string;
    date: string;
  };
}
